import { render, staticRenderFns } from "./AuthorisationDetail.vue?vue&type=template&id=76299a7c"
import script from "./AuthorisationDetail.vue?vue&type=script&lang=js"
export * from "./AuthorisationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports